"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBookingEnabled = exports.shouldShowScheduleAppointmentsSectionOnMobile = exports.normalizeUrl = void 0;
const types_1 = require("./types");
function normalizeUrl(url) {
    return url.endsWith('/') ? url : `${url}/`;
}
exports.normalizeUrl = normalizeUrl;
function shouldShowScheduleAppointmentsSectionOnMobile(bookingStrategy) {
    switch (bookingStrategy) {
        case types_1.BookingStrategies.Availability:
            return true;
        case types_1.BookingStrategies.OpenSchedulingWidget:
            return true;
        case types_1.BookingStrategies.Button:
            return false;
        default:
            return false;
    }
}
exports.shouldShowScheduleAppointmentsSectionOnMobile = shouldShowScheduleAppointmentsSectionOnMobile;
/**
 * Only used when `darkship_feature_flags.use_cta_drawer` is enabled.
 * Used to determine if booking section/aside should display on the profile.
 * Availability and OpenSchedulingWidget strategies always enable booking.
 * showBookingCtaButton prop enables booking when the strategy is Button.
 *
 * @param props
 * @param props.bookingStrategy - The strategy used for booking.
 * @param props.showBookingCtaButton - Indicates whether the booking CTA button should be shown.
 * @returns `true` if booking is enabled, otherwise `false`.
 */
const isBookingEnabled = ({ bookingStrategy, showBookingCtaButton }) => {
    if (bookingStrategy === types_1.BookingStrategies.Button) {
        return showBookingCtaButton;
    }
    return true;
};
exports.isBookingEnabled = isBookingEnabled;
//# sourceMappingURL=utilities.js.map